export const SORT_ORDER_ASC: number = 0;
export const SORT_ORDER_DESC: number = 1;

// default page size
export const SEARCH_DEFAULT_PAGE_SIZE: number = 10;
export const SEARCH_DEFAULT_PAGE_NUMBER: number = 1;

// default column count in case of a partial fetch
export const SEARCH_DEFAULT_COLUMN_COUNT: number = 10;

export const NEW_SEARCH_EVENT: number = 1;
export const ITEM_CLICK_EVENT: number = 2;
// this is the event that gets propogated when a new row is added to the table
export const NEW_ROW_EVENT: number = 3;
// this is the event that gets propogated when a row is deleted from the table
export const DELETE_ROW_EVENT: number = 4;
export const ITEM_AUTO_POPULATE: number = 5;
export const NEW_PAGE_EVENT: number = 6;
// this is the event that triggers a new row to be added to the table
export const AUTO_ADD_ROW_EVENT: number = 7;
export const PAGE_OVERFLOW_EVENT: number = 8;
export const REFRESH_SEARCH_EVENT: number = 9;
export const PAGINATE_EVENT: number = 10;
export const INSERT_ROW_EVENT: number = 11;
export const DUPLICATE_ROW_EVENT: number = 12;
export const NEW_POP_UP_EVENT: number = 13;
export const SHOW_TAB_EVENT: number = 14;
//LFWM-2954 - Refresh event for bottom pinned row.
export const REFRESH_PINNED_ROW_EVENT: number = 15;
export const IS_DETAIL_PAGE_DATA_LOADED: number = 16;

//LFWM-5166 Minimum Column width for Search
export const MINIMUM_COLUMN_WIDTH: number = 70;
export const MINIMUM_DATE_COLUMN_WIDTH: number = 70;
export const DATE_COLUMN_WIDTH: number = 267;
export const DATE_TYPE: string = 'DATE';
export const DATE_TIME_TYPE: string = 'DATETIME';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/search-constants.ts